var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExternalVal)?_c('span',{staticClass:"svg-icon-box"},[_c('span',_vm._g({class:_vm.svgClass,style:(_vm.styleExternalIcon)},_vm.$listeners))]):_c('svg',_vm._g({class:_vm.svgClass,attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }